import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebaseConfig';

let adminSession;
const pendingChecks = new Map();

export async function verifyAdminSession(user) {
    const token = await user.getIdTokenResult();
    if (token.claims?.walletVerified !== true || token.signInProvider !== 'custom') {
        throw Object.assign(new Error('Sign in with your wallet signature.'), { code: 'admin/signature-required' });
    }
    // Navbar and dashboard can share an in-flight check. Results are never persisted.
    const key = user.uid + ':' + token.token;
    if (pendingChecks.has(key)) return pendingChecks.get(key);
    if (!adminSession) adminSession = httpsCallable(functions, 'adminSession', { timeout: 15000 });
    const pending = adminSession({ walletUid: user.uid }).then(({ data }) => {
        if (data?.authorized !== true || data.walletUid !== user.uid) throw new Error('Admin access could not be verified.');
        return data;
    });
    pendingChecks.set(key, pending);
    const clear = () => { if (pendingChecks.get(key) === pending) pendingChecks.delete(key); };
    pending.then(clear, clear);
    return pending;
}
